import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { useExitIntent } from './hooks/useExitIntent'
import ExitDiscountModal from './components/ExitDiscountModal'
import MetaTags from './components/MetaTags'
import ScrollToTop from './components/ScrollToTop'

// Componente interno que tem acesso ao hook
function AppContent() {
  const { showModal, setShowModal } = useExitIntent();

  return (
    <>
      <ScrollToTop />
      <MetaTags />
      <AppRoutes />
      <ExitDiscountModal 
        isOpen={showModal} 
        onClose={() => setShowModal(false)} 
      />
    </>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppContent />
    </BrowserRouter>
  )
}

export default App
